// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2dnEV","dragIcon":"Choice_dragIcon__KR4fo","left":"Choice_left__2znrW","input":"Choice_input__2TYcG"};